import { useEffect } from 'react'

/**
 * The two design systems are switched by an attribute on <body>, not by importing a different
 * stylesheet: the console's tokens override the PLG ones on `[data-surface=console]`, so a shared
 * UI-KIT component picks up whichever system it is rendered inside without knowing about either.
 */
export type Surface = 'plg' | 'console'

export const useSurfaceTheme = (surface: Surface) => {
  useEffect(() => {
    document.body.dataset.surface = surface
    return () => {
      delete document.body.dataset.surface
    }
  }, [surface])
}
